//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

const validateAverage = (min, max, base, nums) => {
    const format = (v) => {
        return v >= min & v <= max ? v : 0;
    };
    return nums.reduce((a, b) => format(a) + format(b)) / 4 - base;
};

class Cube {
    constructor({ lerc, density, min, max, base }) {
        const single = 1 / density;
        const width = single * 3 / 5;
        const border = single / 5;
        this.single = single;
        this.width = width;
        this.border = border;
        this.density = density;
        this.min = min;
        this.max = max;
        this.base = base;
        this.lerc = lerc;

        const { vertices, indices, normals } = this.verticeGenertor();
        this.vertices = vertices;
        this.indices = indices;
        this.normals = normals;

    }
    getBuffer() {
        return this.buffer;
    }
    getVertices() {
        return this.vertices;
    }
    getColors() {
        return this.colors;
    }
    getIndices() {
        return this.indices;
    }
    getNormals() {
        return this.normals;
    }
    getCubeHeight({ coordinate, tileSize = 256 }) {
        const { lerc, width, max, min, base } = this;
        const [originX, originY] = coordinate;
        const x = Math.floor(originX * tileSize);
        const y = Math.floor(originY * tileSize);
        const offset = Math.floor(width * tileSize);
        const i1 = y * x;
        const i2 = y * (x + offset);
        const i3 = (y + offset) * x;
        const i4 = (y + offset) * (x + offset);
        const value = validateAverage(
            min,
            max,
            base,
            [
                lerc[i1],
                lerc[i2],
                lerc[i3],
                lerc[i4],
            ]
        );
        return value;
    }
    // index start 1
    getSingleCube(index) {
        const { density, single, width, border } = this;
        const tmp = [
            1.0, 1.0, 1.0, 1.0, 0.0, 1.0, 1.0, 0.0, 0.0, 1.0, 1.0, 0.0,    // v0-v3-v4-v5 right
            1.0, 1.0, 1.0, 0.0, 1.0, 1.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0,    // v0-v1-v2-v3 front
            1.0, 1.0, 1.0, 1.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0,    // v0-v5-v6-v1 up
            0.0, 1.0, 1.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0,    // v1-v6-v7-v2 left
            0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 0.0, 0.0, 1.0,    // v7-v4-v3-v2 down
            1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0
        ];
        const verticesModel = tmp.map(vertice => vertice * width);

        const x = (index % density) ? index % density : density;
        const y = Math.ceil(index / density);
        const xPoint = (x - 1) * single + border;
        const yPoint = (y - 1) * single + border;
        const coordinate = [xPoint, yPoint];
        const height = this.getCubeHeight({ coordinate });
        if (height <= 0.0001) {
            return null;
        }
        const vertices = verticesModel.map((item, index) => {
            switch ((index + 1) % 3) {
            case 0:
                return height * item;
            case 1:
                return xPoint + item;
            case 2:
                return yPoint + item;
            default:
                return null;
            }
        });
        return vertices;
    }
    // index start from 1
    getSingleIndices(index) {
        const tmp = [
            0, 1, 2, 0, 2, 3,    // front
            4, 5, 6, 4, 6, 7,    // right
            8, 9, 10, 8, 10, 11,    // up
            12, 13, 14, 12, 14, 15,    // left
            16, 17, 18, 16, 18, 19,    // down
            20, 21, 22, 20, 22, 23     // back
        ];
        const offsetIndex = (index - 1) * 24;
        const indices = tmp.map(index => index + offsetIndex);
        return indices;
    }

    getSingleNormals() {
        const tmp = [
            0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0,  // v0-v1-v2-v3 front
            1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0,  // v0-v3-v4-v5 right
            0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0,  // v0-v5-v6-v1 up
            -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0,  // v1-v6-v7-v2 left
            0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0,  // v7-v4-v3-v2 down
            0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0   // v4-v7-v6-v5 back
        ];
        return tmp;
    }

    verticeGenertor() {
        const { density } = this;
        const _vertices = [];
        const _indices = [];
        const _normals = [];
        let i = 0;
        let validate = 0;
        while (++i <= density * density) {
            const singleCubeVertices = this.getSingleCube(i);
            if (singleCubeVertices) {
                validate++;
                _vertices.push(...singleCubeVertices);
                _indices.push(...this.getSingleIndices(validate));
                _normals.push(...this.getSingleNormals());
            }
        }
        return {
            vertices: new Float32Array(_vertices),
            indices: new Uint16Array(_indices),
            normals: new Float32Array(_normals),
        };
    }
}

module.exports = Cube;
